import { html } from '@resn/gozer-core';
import Svg from 'component/svg';

import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';

import './index.scss';
import { COLORS } from 'core/constants';

const template = ({ props, options }) => html`
    <div class="scrollArrows" style="color: ${options.color}; display: ${props.v ? 'block' : 'none'};">
        ${Svg('arrow-scroll', 'scrollArrows__arrow')} ${Svg('arrow-scroll', 'scrollArrows__arrow')}
        ${Svg('arrow-scroll', 'scrollArrows__arrow')}
    </div>
`;

@componentMixin(DomComponentMixin)
class ScrollArrows extends Component {
    options = {
        template,
        color: COLORS.LIGHT_BLUE_2,
    };

    props = {
        v: true,
    };
}

export default ScrollArrows;
